exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".dialog-ad-version-shield{width:840px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-15b924d5!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/views/OperationManage/SystemConfig/SystemConfig/Components/AdVersionShield.vue
// module id = 450
// module chunks = 0